import './Footer.css';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaInstagram } from 'react-icons/fa';

const Footer = () => (
    <footer className='footer'>
        <div className='footer-content'>
            <div className='footer-about-section'>
                <h3>ABOUT US</h3>
                <div className='section-underline'></div>
                <p>We Dentists are to here serve you best, a place dedicated to clear, white & perfect smiles.</p>
                
                <div className='contact-info'>
                    <div className='contact-item address'>
                        <div className='contact-icon-wrapper'>
                            <FaMapMarkerAlt className='contact-icon' />
                        </div>
                        <div className='contact-details'>
                            <span className='contact-label'>Address</span>
                            <a 
                                target="_blank" 
                                rel="noreferrer" 
                                href='https://maps.app.goo.gl/FHrdhMCpvA2wHJ3U8'
                                className='contact-link address-link'
                            >
                                120, Huda Market Sector 23, Gurugram, Haryana
                            </a>
                        </div>
                    </div>
                    
                    <div className='contact-item phone'>
                        <div className='contact-icon-wrapper'>
                            <FaPhoneAlt className='contact-icon' />
                        </div>
                        <div className='contact-details'>
                            <span className='contact-label'>Phone</span>
                            <a 
                                target="_blank" 
                                rel="noreferrer" 
                                href='tel:+918076353837'
                                className='contact-link'
                            >
                                +91-8076353837
                            </a>
                        </div>
                    </div>
                    
                    <div className='contact-item email'>
                        <div className='contact-icon-wrapper'>
                            <FaEnvelope className='contact-icon' />
                        </div>
                        <div className='contact-details'>
                            <span className='contact-label'>Email</span>
                            <a 
                                target="_blank" 
                                rel="noreferrer" 
                                href='mailto:contactwisdomdentalclinic@gmail.com'
                                className='contact-link'
                            >
                                contactwisdomdentalclinic@gmail.com
                            </a>
                        </div>
                    </div>
                    
                    <div className='contact-item social'>
                        <div className='contact-icon-wrapper'>
                            <FaInstagram className='contact-icon' />
                        </div>
                        <div className='contact-details'>
                            <span className='contact-label'>Instagram</span>
                            <a 
                                href="https://www.instagram.com/wisdomdental_gurugram?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
                                target="_blank" 
                                rel="noreferrer"
                                className='contact-link'
                            >
                                @wisdomdental_gurugram
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className='footer-services-section'>
                <h3>SERVICES</h3>
                <div className='section-underline'></div>
                <ul className='services-list'>
                <li><i className='bullet-dot'></i>Dental Implants</li>
                <li><i className='bullet-dot'></i>Braces & Invisalign</li>
                <li><i className='bullet-dot'></i>Root Canal Treatment</li>
                <li><i className='bullet-dot'></i>Teeth Whitening</li>
                <li><i className='bullet-dot'></i>Dental Crowns & Bridges</li>
                <li><i className='bullet-dot'></i>Tooth-Colored Fillings</li>
                <li><i className='bullet-dot'></i>Wisdom Tooth Extraction</li>
                <li><i className='bullet-dot'></i>Gum Disease Treatment</li>
                <li><i className='bullet-dot'></i>Full Mouth Rehabilitation</li>
                <li><i className='bullet-dot'></i>Gum Disease Treatment</li>
                </ul>
            </div>
        </div>
    </footer>
);

export default Footer;